import "../css/category-slider.css";
import { useEffect, useRef, useState } from "react";

function CategorySlider({ list: categoryList, click }) {
  const [width, setWidth] = useState(50);
  const sliderBoxRef = useRef(null);
  const contentRef = useRef(null);

  useEffect(() => {
    if (sliderBoxRef.current) {
      setWidth(sliderBoxRef.current.offsetWidth);
    }
  }, []);

  const scroll = (offset) => {
    if (contentRef.current) {
      contentRef.current.scrollLeft += offset;
    }
  };

  const handleClick = (e, id) => {
    const buttons = contentRef.current.querySelectorAll("button");
    buttons.forEach((btn) => btn.classList.remove("active"));
    e.currentTarget.classList.add("active");
    click(e, id); // You can pass id or entire item if needed
  };

  if (!categoryList) return null;

  return (
    <div className="slider-container">
      <div
        className="controller controller-left"
        onClick={() => scroll(-width)}
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="16"
          height="16"
          viewBox="0 0 256 512"
        >
          <path
            fill="currentColor"
            d="M192 448c-8.188 0-16.38-3.125-22.62-9.375l-160-160c-12.5-12.5-12.5-32.75 
            0-45.25l160-160c12.5-12.5 32.75-12.5 45.25 0s12.5 32.75 0 45.25L77.25 256l137.4 
            137.4c12.5 12.5 12.5 32.75 0 45.25C208.4 444.9 200.2 448 192 448z"
          />
        </svg>
      </div>

      <div className="slider-box" ref={sliderBoxRef}>
        <div className="content-container" ref={contentRef}>
          {categoryList.map((item, index) => (
            <button
              key={index}
              className="category-button"
              data-id={item.list_name_encoded}
              onClick={(e) => handleClick(e, item.list_name_encoded)}
            >
              {item.display_name}
            </button>
          ))}
        </div>
      </div>

      <div
        className="controller controller-right"
        onClick={() => scroll(width)}
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="16"
          height="16"
          viewBox="0 0 256 512"
        >
          <path
            fill="currentColor"
            d="M64 448c-8.188 0-16.38-3.125-22.62-9.375c-12.5-12.5-12.5-32.75 
            0-45.25L178.8 256L41.38 118.6c-12.5-12.5-12.5-32.75 0-45.25s32.75-12.5 
            45.25 0l160 160c12.5 12.5 12.5 32.75 0 45.25l-160 160C80.38 444.9 
            72.19 448 64 448z"
          />
        </svg>
      </div>
    </div>
  );
}

export default CategorySlider;
